export default "__VITE_ASSET__BvLG7hFh__ 400w, __VITE_ASSET__CjwQXIJw__ 800w, __VITE_ASSET__B5G1vjHG__ 1024w";